import type { Variants, Transition } from "motion/react";

/**
 * Animation variants for icons that pop up with a scale and fade effect
 */
export const iconPopupVariants: Variants = {
  initial: { opacity: 0, scale: 0.5 },
  animate: { opacity: 1, scale: 1 },
};

/**
 * Transition config for icon popup animation with a small delay
 */
export const iconPopupTransition: Transition = {
  duration: 0.2,
  delay: 1,
  ease: "easeOut",
};
